import * as i0 from "@angular/core";
export class LoginHeaderStore {
}
LoginHeaderStore.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function LoginHeaderStore_Factory() { return new LoginHeaderStore(); }, token: LoginHeaderStore, providedIn: "root" });
export var LoginHeaderStoreKeys;
(function (LoginHeaderStoreKeys) {
})(LoginHeaderStoreKeys || (LoginHeaderStoreKeys = {}));
